/** Strings for the Recipes page and the recipe cards (S13). */
export const recipesCopy = {
  title: 'Recipes',
  crumb: 'recipes',
  workspaceFallback: 'workspace',
  retry: 'Retry',
  sections: { installed: 'Set up', available: 'Available' },
  loadFailed: 'Could not load recipes.',
  installsLoadFailed: 'Could not load the recipes set up here.',
  installed: { empty: 'No recipes set up yet.' },
  catalog: {
    empty: 'No recipes available.',
    setUp: 'Set up',
    setUpName: (title: string) => `Set up ${title}`,
    source: (label: string) => `Takes events from a ${label}.`,
    workspaceOrigin: 'Workspace',
  },
  status: { on: 'on', paused: 'paused', noAgent: 'no agent' },
  install: {
    source: 'Source',
    topic: 'Topic',
    agent: 'Agent',
    topicName: (name: string) => `#${name}`,
    topicFallback: 'topic',
    any: 'any',
    needsSetup: (name: string, reason: string) =>
      `${name} needs setup — ${reason}`,
    pause: 'Pause',
    resume: 'Resume',
    change: 'Change setup',
    remove: 'Remove',
    removeTitle: 'Remove recipe',
    removeDescription:
      'Removes its routes and workflows. The topic and its threads stay.',
    removeConfirm: 'Remove',
    pauseFailed: (reason: string) => `Failed to pause the recipe — ${reason}`,
    resumeFailed: (reason: string) => `Failed to resume the recipe — ${reason}`,
    removeFailed: (reason: string) => `Failed to remove the recipe — ${reason}`,
  },
  setup: {
    source: 'Source',
    chooseSource: 'Choose a source',
    noSource: (label: string) => `No ${label} yet.`,
    addSource: 'Add resource',
    /** `{name}` is a link to the source; `{reason}` is the server's. */
    needsSetup: '{name} needs setup — {reason}',
    topic: 'Topic',
    newTopic: 'New topic',
    topicName: 'New topic name',
    agent: 'Agent',
    chooseAgent: 'Choose an agent',
    newAgent: 'New agent',
    /** `{settings}` is a link to the workspace settings. */
    noProvider: 'No LLM provider configured — add one in {settings}.',
    settingsLink: 'workspace settings',
    setUpFailed: (reason: string) => `Failed to set up the recipe — ${reason}`,
    saveFailed: (reason: string) => `Failed to save changes — ${reason}`,
    submit: 'Set up',
    save: 'Save changes',
    cancel: 'Cancel',
    done: 'Done',
    setUpWithWarnings: 'Recipe set up — some of it will not work',
  },
  usage: {
    heading: 'Used by',
    loadFailed: 'Could not load the recipes using this connection.',
    empty: 'No recipe uses this connection yet.',
    setUp: 'Set up a recipe',
    paused: 'paused',
  },
} as const
